module.exports = __webpack_public_path__ + "pic/47.210235bd.png";